<template>
	<div class="signin">
		<div class="signin__container">
			<div class="container">
				<div class="signin__header">
					<div class="h1 h1--light h1--bold signin__heading">Najwyższej jakości fotochemiczne metody wykonywania offsetowych form drukowych</div>
				</div>
			</div>
		</div>
		<div class="signin__container signin__container--light" v-if="!userData">
			<div class="container">
				<div class="signin__content">
					<div class="signin__copy">Zaloguj się, aby uzyskać dostęp do naszych usług lub załóż konto.</div>
					<ButtonPrimary v-on:click="redirectToLogin()" class="button--big">Login / Rejestracja</ButtonPrimary>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/components/login-required';
</style>

<script>
import { mapGetters } from 'vuex'
import { getterTypes } from '@/store/modules/User/getter-types'

export default {
	name: 'LoginRequired',
    computed: {
        userData() {
            return this.GET_USER_DATA();
        },
    },
    components: {
		'ButtonPrimary': () => import('@/pages/components/buttons/ButtonPrimary'),
	},
	methods: {
        ...mapGetters('UserModule', [
			getterTypes.GET_USER_DATA,
        ]),
		redirectToLogin() {
			this.$router.push({ name: 'Login' });
		}
	}
}
</script>